import { Api } from "../Api";
import { Question } from "./Question";

import { ResponsesQuestion } from "./Responses";

export class QuestionsList extends Api {
  static #questions = [];
  static #questionsList = [];
  static #responses = [];
  //static #messagesList = {};

  constructor() {}

  static buildUrlWithParams(baseUrl, params) {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ""
      )
    );

    const queryString = new URLSearchParams(filteredParams).toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  }

  static async getQuestions(allQueryParams) {
    let url = this.buildUrlWithParams("/question/", allQueryParams);

    this.#questions = await this.get(url);
    const { success, error } = this.#questions;

    if (success) {
      return this.prepareObjQuestionList();
    } else {
      throw {
        errMsj: error["message"],
        intCod: error["cod"],
        imagesList: error["images"],
        messagesList: error["messages"],
      };
    }
  }

  static prepareObjQuestionList() {
    const { questions } = this.#questions["data"];
    const {
      estatuscaptcha,
      estatusEnumera,
      estatusTextoEstrellas,
      messages,
      images,
      slides,
      preguntasxSlide,
      mostarContadorTexto,
      maxCaracteresTexto,
      parametrosURL,
      encuestaVigente,
    } = this.#questions;
    //console.log(encuestaVigente)
    //this.prepareObjMessages(messages);
    let recordset = questions["recordset"];

    let PreguntaId = 0;
    this.#questionsList = [];

    recordset.forEach((q) => {
      let question = new Question();

      if (PreguntaId !== q.PreguntaId) {
        this.setDatQuestion(question, q);
        this.#questionsList.push(question);
      }

      let r = new ResponsesQuestion();
      this.setDataResponse(r, q);
      let found = this.#questionsList.find(
        (e) => e.PreguntaId === q.PreguntaId
      );
      if (found) {
        found.response.push(r);
      }

      PreguntaId = q.PreguntaId;
    });

    return {
      questions: this.#questionsList,
      status: estatuscaptcha,
      showStars: estatusTextoEstrellas,
      enumera: estatusEnumera,
      messagesList: messages,
      imagesList: images,
      slides: slides,
      pregXSlide: preguntasxSlide,
      mostarContadorTexto: mostarContadorTexto,
      maxCaracteresTexto: maxCaracteresTexto,
      parametrosURL: parametrosURL,
      encuestaVigente: encuestaVigente,
    };
  }

  static setDatQuestion(question, q) {
    question.PreguntaId = q.PreguntaId;
    question.PreguntaIdPadre = q.PreguntaIdPadre;
    question.PreguntaNro = q.PreguntaNro;
    question.PreguntaObligatoria = q.PreguntaObligatoria;
    question.PreguntaOrden = q.PreguntaOrden;
    question.PreguntaTexto = q.PreguntaTexto;
    question.PreguntaTextoEnriquecido = q.PreguntaTextoEnriquecido;
    question.PreguntaTextoAdicional = q.PreguntaTextoAdicional;
    question.PreguntaTipoTextoAdicional = q.PreguntaTipoTextoAdicional;
    question.response = [];
  }

  static setDataResponse(r, q) {
    r.RespuestaActivaSubPregunta = q.RespuestaActivaSubPregunta;
    r.RespuestaId = q.RespuestaId;
    r.RespuestaOrden = q.RespuestaOrden;
    r.RespuestaTexto = q.RespuestaTexto;
    r.RespuestaTipo = q.RespuestaTipo;
    r.SubPreguntaId = q.SubPreguntaId;
    r.SubPreguntaId2 = q.SubPreguntaId2;
    r.RespuestaQuality = q.RespuestaQuality;
    r.PreguntasMaxCaracteres = q.PreguntasMaxCaracteres;
  }
}
